import {AuthData, AuthHeaders, AuthInfo} from "../models/auth";
import {authService} from "../plugins/axios";

class AuthService {
  public static async auth(): Promise<AuthData> {
    const authData = await authService
      .post(`auth/sign_in`, {
        user: {
          email: 'preview@anyplay.audio',
          password: 'yNHcV9~$)z[Qcv~5'
        }
      })
    let headers = AuthService.getHeaders(authData.headers);
    let data: AuthInfo = authData.data.data;
    let resp: AuthData = {headers, data};
    return resp;
  }

  public static getHeaders(headers: any): AuthHeaders {
    return {
      'access-token': headers['access-token'],
      'token-type': headers['token-type'],
      client: headers.client,
      expiry: headers.expiry,
      uid: headers.uid
    };
  }
}
export default AuthService
